/**
 * @generated SignedSource<<4ad16f8b4f7030b0e427a9269e5928d4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PolicyCollectionItemsInput = {
  items: ReadonlyArray<PolicyCollectionElement>;
  uuid: string;
};
export type PolicyCollectionElement = {
  policyUUID: string;
  policyVersion?: number | null | undefined;
};
export type AddPolicyCollectionItemsMutation$variables = {
  input: PolicyCollectionItemsInput;
};
export type AddPolicyCollectionItemsMutation$data = {
  readonly addPolicyCollectionItems: {
    readonly collection: {
      readonly policyMappings: {
        readonly pageInfo: {
          readonly total: number | null | undefined;
        };
      };
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
};
export type AddPolicyCollectionItemsMutation = {
  response: AddPolicyCollectionItemsMutation$data;
  variables: AddPolicyCollectionItemsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PolicyCollectionMappingConnection",
  "kind": "LinkedField",
  "name": "policyMappings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddPolicyCollectionItemsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "addPolicyCollectionItems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AddPolicyCollectionItemsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "addPolicyCollectionItems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d2610e658542012c50adb11c7583c88",
    "id": null,
    "metadata": {},
    "name": "AddPolicyCollectionItemsMutation",
    "operationKind": "mutation",
    "text": "mutation AddPolicyCollectionItemsMutation(\n  $input: PolicyCollectionItemsInput!\n) {\n  addPolicyCollectionItems(input: $input) {\n    collection {\n      policyMappings {\n        pageInfo {\n          total\n        }\n      }\n      uuid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b140a9d60613e99350ea824c0cddf830";

export default node;
